export class Events {
    Id!: string;
    Name!: string;
    Description!: string;
    IsPredefined!: boolean;
    CreatedDate!: Date;
    EmailTemplates?: null;
    EmailEventParameters?: null;
    EmailParameterIds!: string[];
}

export class SaveEvents {
    id!: string;
    name!: string;
    description!: string;
    isPredefined!: boolean;
    createdDate!: Date;
    emailParameterIds?: string[];
}

export class Parameters {
    Guid!: string;
    ParameterName!: string;
    ParameterDescription!: string;
    ParameterUsage!: null;
}

export class Templates {
    Id!: string;
    EmailEventId!: string;
    HtmlText!: string;
    Subject!: string;
    CreatedDate!: Date;
    ModifiedDate!: Date | null;
    EventTypeViewModel!: Events;
}

export class SaveTemplates {
    Guid!: string;
    HtmlText!: string;
    EmailEventId!: string;
    Subject!: string;
    IsSendToBccEmail?: boolean;  // Changed from isSendToBccEmail to IsSendToBccEmail

}